// Copyright © 2026 Qcells. All rights reserved.
//
// This software is proprietary and confidential. Unauthorized use,
// duplication, or distribution of software is strictly prohibited.

import { useAuth } from '../../helios/hooks/useAuth';
import { FLEET_ID } from '../../helios/hooks/useActiveSite';
import { personaForRole } from '../../helios/hooks/usePersona';
import { useShellStore } from '../../helios/stores/shellStore';

/** Shared rollout scope. Persona previews must not change the real selection. */
export function useSiteSelection() {
  const { sites, effectiveRole } = useAuth();
  const selectedSiteId = useShellStore(state => state.selectedSiteId);
  const setSelectedSite = useShellStore(state => state.setSelectedSite);
  const canSelectFleet = personaForRole(effectiveRole) === 'manager';
  const isFleet = canSelectFleet && (selectedSiteId === null || selectedSiteId === FLEET_ID);

  return {
    selectedSiteId: isFleet ? null : (selectedSiteId ?? sites[0]?.site_id ?? null),
    canSelectFleet,
    selectSite(id: string | null) {
      if (id === null && canSelectFleet) {
        setSelectedSite(FLEET_ID, 'Whole fleet');
      } else {
        const site = sites.find(item => item.site_id === id);
        if (!site) throw new Error('Cannot select a site outside the current roster.');
        setSelectedSite(site.site_id, site.label);
      }
    },
  };
}
